import { KitActionTypes, KitActions } from './types';
import { Kit } from '../../models/kit';

const initialState: Kit = {
  history: [],
  error: undefined,
};

const kitReducers = (state = initialState, action: KitActions) => {
  switch (action.type) {
    case KitActionTypes.ACTION_KIT_STATUS_SUBMIT:
      return {
        ...state,
      };
    case KitActionTypes.ACTION_KIT_STATUS_SUBMIT_SUCCESS:
      return {
        ...state,
        history: action.payload.history,
      };
    case KitActionTypes.ACTION_KIT_STATUS_SUBMIT_ERROR:
      return {
        ...state,
        error: action.error,
      };

    case KitActionTypes.ACTION_KIT_ACTIVATE_SUBMIT:
      return {
        ...state,
      };
    case KitActionTypes.ACTION_KIT_ACTIVATE_SUBMIT_SUCCESS:
      return {
        ...state,
      };
    case KitActionTypes.ACTION_KIT_ACTIVATE_SUBMIT_ERROR:
      return {
        ...state,
        error: action.error,
      };
  }
  return state;
};

export default kitReducers;